export const landingVariants = ['proof-first', 'before-after', 'student-proof'] as const

export type LandingVariant = (typeof landingVariants)[number]

export const landingVariantLabels: Record<LandingVariant, string> = {
  'proof-first': 'Proof first',
  'before-after': 'Before & after',
  'student-proof': 'Student proof',
}

export function isLandingVariant(value: string): value is LandingVariant {
  return landingVariants.includes(value as LandingVariant)
}

export const landingCopy = {
  eyebrow: 'AI portfolio builder for college students',
  headline: 'Turn coursework into proof employers can see.',
  subheadline:
    'Upload a class project. Skill Bridger extracts the challenge, decisions, skills, and results, then creates a portfolio case you can share.',
  primaryCta: 'Create free preview',
  primaryHref: '/auth/signup',
  heroProof: 'From class assignment to career-ready story.',
  heroQuote:
    'Skill Bridger turned my classwork into a professional-looking project connected to real-world fields like animal genetics and biotechnology.',
  heroAttribution: 'Raissa, Veterinary Medicine student',
} as const

export function getFreePreviewCtaHref(marketingOnly: boolean, guestPreviewEnabled = false) {
  return marketingOnly ? '/join' : guestPreviewEnabled ? '/preview' : landingCopy.primaryHref
}

export const heroTrustSignals = [
  'Built from your work, not invented by AI',
  'Employer-ready structure',
  'Nothing is published until you approve',
] as const

export const studentQuotes = [
  {
    quote: 'It connected my classwork to real-world fields like animal genetics and biotechnology.',
    name: 'Raissa',
    field: 'Veterinary Medicine',
  },
  {
    quote: 'It truly adds value by organizing and presenting the information professionally.',
    name: 'Cassia',
    field: 'Psychology',
  },
  {
    quote: 'It helped me turn the work I did into a clear project story I could confidently explain.',
    name: 'Lincoln',
    field: 'Business Administration',
  },
  {
    quote: 'It read and understood the requirements document I uploaded.',
    name: 'Artur',
    field: 'Computer Science',
  },
] as const

export const productImages = {
  review: {
    src: '/marketing/review-and-refine-current.png',
    width: 857,
    height: 630,
    alt: 'Skill Bridger review screen showing an editable AI-suggested project insight and supporting guidance',
  },
  project: {
    src: '/marketing/public-project-and-linkedin.png',
    width: 1440,
    height: 3828,
    alt: 'A real Skill Bridger public project with evidence, resume bullets, and a LinkedIn draft',
  },
  portfolio: {
    src: '/marketing/public-portfolio.jpg',
    width: 1280,
    height: 2726,
    alt: 'A real Skill Bridger student portfolio containing published project cases',
  },
} as const
